/**
 * Countdown: updates all [data-countdown-timer] every second.
 * Attributes: data-year, data-month (1-12), data-day, data-hour, data-minute, data-second
 */
function formatTargetDate(el) {
  const y = parseInt(el.getAttribute('data-year'), 10);
  const mo = parseInt(el.getAttribute('data-month'), 10);
  const d = parseInt(el.getAttribute('data-day'), 10);
  const h = parseInt(el.getAttribute('data-hour') || '0', 10);
  const mi = parseInt(el.getAttribute('data-minute') || '0', 10);
  const s = parseInt(el.getAttribute('data-second') || '0', 10);
  if (Number.isNaN(y) || Number.isNaN(mo) || Number.isNaN(d)) {
    return null;
  }
  return new Date(y, mo - 1, d, h, mi, s, 0);
}

function pad2(n) {
  return n < 10 ? `0${n}` : String(n);
}

function updateCountdown(el) {
  const end = formatTargetDate(el);
  if (!end) {
    el.textContent = '--d --:--:--';
    return;
  }
  const now = new Date();
  let diff = end.getTime() - now.getTime();
  if (diff <= 0) {
    el.textContent = '0d 00:00:00';
    el.setAttribute('data-countdown-finished', 'true');
    return;
  }
  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  // Days, then HH:MM:SS. Compact, single-line — fits the existing
  // `.product-highlight__countdown-display` span without re-templating.
  el.textContent = `${days}d ${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;
  el.removeAttribute('data-countdown-finished');
}

function tickAll() {
  document.querySelectorAll('[data-countdown-timer]').forEach((el) => {
    try {
      updateCountdown(el);
    } catch (e) {
      /* ignore */
    }
  });
}

function startCountdownLoop() {
  tickAll();
  if (window.__countdownTimerIntervalId) {
    return;
  }
  window.__countdownTimerIntervalId = setInterval(tickAll, 1000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function onReady() {
    document.removeEventListener('DOMContentLoaded', onReady);
    startCountdownLoop();
  });
} else {
  startCountdownLoop();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    tickAll();
  });
}
